<template>
<div>
  <section class="sub-content membership" id="agreeTermSection"  v-if="step==1">
  <div id="container" class="login">
    <div class="joinDamda">
      <div class="joinTit aniBox2  gogo">
        <center>회원가입은 간단합니다.</center>
        <strong>회원가입</strong>
        <p>STEP 1. 약관동의</p>
      </div>

      <div class="joinBox">
        <div class="joinStep01 aniBox">
          <div class="conTitWrap mgb10 aniBox type_left gogo">
            <strong>DAMDA 이용약관</strong>
          </div>
          <div class="policyWrap">
            <div class="policy aniBox type_bot gogo">
            <div class="terms-box" style="height:auto;border:0">
               <h1>제 1 장 총칙</h1>
               <h2>제1조 (목적)</h2>
               <div class="terms-conditions">
                 이 약관은 DAMDA(이하 "담다"라 함)가 제공하는 홈페이지(godamda.kr) 서비스(이하 "서비스"라 함)의 이용조건 및 절차에 관한 사항을 규정함을 목적으로 합니다.
               </div>
               <h2>제2조 (약관의 효력 및 변경)</h2>
               <div class="terms-conditions">
                 ① 이 약관은 담다의 홈페이지 서비스 화면으로 이용 고객에게 그 내용을 공지함으로써 효력이 발생합니다.<br>
                 ② 담다는 필요하다고 인정되는 경우에 이 약관을 개정할 수 있으며, 개정된 내용은 제1항과 같은 방법으로 공지한 때로부터 그 효력을 발생합니다.
               </div>
               <h2>제3조 (약관적용 외 준칙)</h2>
               <div class="terms-conditions">
                 이 약관에 명시되지 않은 사항이 관계법령에 규정되어 있는 경우에는 그 규정에 따릅니다.
               </div>
               <h2>제4조 (용어의 정의)</h2>
               <div class="terms-conditions">
                 ① 이 약관에서 사용하는 용어의 정의는 다음 각 호와 같습니다.<br>
                 1. "서비스"라 함은 홈페이지에서 제공하는 제반서비스(정보제공, 부가서비스 등)를 말합니다.<br>
                 2. "회원"이라 함은 담다와 서비스 이용계약을 체결하고 회원ID를 부여받은 개인 또는 법인을 말합니다.<br>
                 3. "이용계약"이라 함은 서비스 이용을 목적으로 담다와 이용자간에 체결하는 계약을 말합니다.<br>
                 4. "회원ID"라 함은 회원의 식별과 회원의 서비스이용을 위하여 회원이 선정하고 담다가 승인하는 문자와 숫자의 조합을 말합니다.<br>
                 5. "회원정보"라 함은 회원이 이용계약을 체결할때 담다에 등록하는 회원ID, 이름, 전화번호, 직업 등의 회원에 관한 정보를 말합니다.<br>
                 6. "비밀번호"라 함은 회원ID와 일치된 회원임을 확인하고 회원 자신의 비밀을 보호하기 위하여 회원 자신이 설정한 문자와 숫자의 조합을 말합니다.
               </div>

               <h1>제 2 장 이용계약 체결</h1>
               <h2>제5조 (이용계약(회원가입) 체결)</h2>
               <div class="terms-conditions">
                 ① 회원에 등록하여 서비스를 이용하고자 하는 자는 담다에서 요청하는 회원에 관한 정보를 본인이 성실하게 작성, 등록함을 원칙으로 합니다.<br>
                 ② 회원등록은 이용 희망자가 본 이용약관을 열람한 후 회원 가입신청서 양식에 따라 관련사항을 기재하고 "동의함" 버튼을 누르면 이 약관에 합법적으로 동의하는 것으로 간주합니다.<br>
                 ③ 이용자가 모든 사항을 성실히 기재하여 이용 신청을 완료하였을때 담다가 이용 신청에 대해 승낙함으로써 계약이 체결됩니다.
               </div>
               <h2>제6조 (계약 해지)</h2>
               <div class="terms-conditions">
                 ① 이용자가 서비스 이용 계약을 해지하고자 하는 때에는 이용자 본인이 사전에 온라인, E-mail, 방문, 전화, 또는 팩스를 통하여 담다에 해지 신청을 해야 합니다.<br>
                 ② 회원에게 다음 각 항에 해당하는 사유가 발생하였을 경우 담다는 사전 통보 없이 계약을 해지 할 수 있습니다.<br>
                 1. 담다의 명예를 훼손하였을 경우<br>
                 2. 서비스 운영을 고의로 방해한 경우<br>
                 3. 타인 회원ID 및 비밀번호를 도용한 경우<br>
                 4. 가입 신청서를 허위로 작성한 경우<br>
                 5. 국익 및 사회 공익을 저해하는 행위를 계획 또는 실행한 경우<br>
                 6. 기타 담다가 회원으로서 부적합하다고 판단한 경우
               </div>

               <h1>제 3 장 서비스 이용</h1>
               <h2>제7조 (서비스 제공 및 광고의 게재)</h2>
               <div class="terms-conditions">
                 ① 담다는 서비스의 무료 운용과 관련하여 서비스 화면, 홈페이지, 이메일 등에 광고를 게재 할 수 있습니다.<br>
                 ② 담다는 필요한 경우에는 서비스의 내용을 추가 또는 변경할 수 있습니다. 이때 담다는 그 내용을 사전에 공지사항으로 공시합니다.
               </div>
               <h2>제8조 (서비스 이용)</h2>
               <div class="terms-conditions">
                 ① 서비스 이용은 담다의 업무상 또는 기술상 특별한 지장이 없는한 연중무휴, 1일 24시간 제공을 원칙으로 합니다.<br>
                 ② 단, 천재지변, 정부예산의 변경, 타 기관에 의한 사유, 시스템 점검 등 담다가 필요한 경우 또는, 시스템 장애, 서비스 이용의 폭주 등 불가항력으로 인하여 서비스를 중단 할 수 있습니다.<br>
                 ③ 담다는 회원이 보다 효과적으로 활용할 수 있도록 서비스 사항에 대한 변동 내용을 공지하여야 합니다.<br>
                 ④ 회원은 담다로부터 검색한 자료의 지적재산권에 관한 사항과 데이터베이스 제작자가 요구하는 사항을 준수하여야 합니다.
               </div>
               <h2>제9조 (서비스 제공의 제한 및 중지)</h2>
               <div class="terms-conditions">
                 ① 담다는 다음 각 호에 해당하는 경우 서비스 제공의 일부 또는 전부를 제한하거나 중지 할 수 있습니다.<br>
                 1. 서비스용 설비의 보수, 정기점검 또는 공사로 인한 부득이한 경우<br>
                 2. 전기통신사업법에 규정된 기간통신사업자가 전기통신 서비스를 중지했을 경우<br>
                 3. 전시, 사변, 천재지변 또는 이에 준하는 국가비상사태가 발생하거나 발생할 우려가 있는 경우<br>
                 4. 서비스 설비의 장애 또는 서비스 이용의 폭주 등으로 서비스 이용에 지장이 있는 경우<br>
                 5. 제12조 회원의 의무를 현저히 위반했을 경우<br>
                 ② 담다는 제1항의 규정에 의하여 서비스 제공의 일부 또는 전부를 제한하거나 중지 할 때에는 그 사유 및 제한기간 등을 지체없이 공지사항이나 이메일 등을 통하여 회원에게 알립니다.
               </div>

               <h1>제 4 장 권리 및 의무</h1>
               <h2>제10조 (담다의 의무)</h2>
               <div class="terms-conditions">
                 ① 담다는 이 약관 및 관계법령에 따라 계속적, 안정적으로 서비스를 제공할 수 있도록 최선의 노력을 다합니다.<br>
                 ② 담다는 회원으로부터 제기되는 의견이나 불만이 정당하다고 인정할 경우에는 적절한 절차를 거쳐 신속히 처리하며, 처리 기간이 지연될 경우 회원에게 지연 사유와 처리일정을 알려드립니다.<br>
                 ③ 담다는 회원이 담다의 서비스 제공으로부터 기대되는 이익을 얻지 못하였거나 서비스 자료에 대한 취사선택 또는 이용으로 발생하는 손해 등에 대하여는 책임을 면합니다.
               </div>
               <h2>제11조(회원정보의 보호)</h2>
               <div class="terms-conditions">
                 ① 담다는 회원의 정보를 운영하거나 개선하는 목적으로만 사용합니다.<br>
                 ② 담다가 취득한 회원정보는 1항에 기재된 목적으로 만 사용하며, 본인의 승낙없이 제3자에게 공개하지 않습니다.<br>
                 다만, 물품배달의 목적의 경우 배달에 필요한 정보만 제공하며 그 외의 경우는 제외합니다.<br>
                 ③ 담다는 회원정보의 보호에 최선을 다합니다.
               </div>
               <h2>제12조 (회원의 의무)</h2>
               <div class="terms-conditions">
                 ① 회원은 관계 법령, 본 약관의 규정, 이용안내 및 서비스상에 공지한 주의사항, 담다가 통지하는 사항을 준수하여야 하며, 기타 담다의 업무에 방해되는 행위를 하여서는 아니됩니다.<br>
                 ② 회원은 서비스를 이용하여 얻은 홈페이지의 정보를 담다의 사전 승낙없이 복사, 복제, 변경, 번역, 출판, 방송, 기타의 방법으로 사용하거나 이를 타인에게 제공 할 수없습니다.<br>
                 ③ 회원은 자신의 회원ID와 비밀번호를 유지 관리할 책임이 있으며, 자신의 회원ID와 비밀번호를 사용하여 발생하는 모든 결과에 대해 전적인 책임이 있습니다. 또한 자신의 회원ID와 비밀번호가 자신의 승낙없이 사용되었을 경우 즉시 담다에 신고하여야 합니다.<br>
                 ④ 회원은 이용 신청시의 기재내용에 대해 진실하고 정확하며 현재의 사실과 일치하도록 유지하고 갱신하여야 합니다.<br>
                 ⑤ 회원은 음란물 게재, 유포 등 사회질서를 해치는 행위, 타인의 명예를 훼손하거나 모욕하는 행위와 타인의 지적재산권 등의 권리를 침해하는 행위를 할 수 없습니다.
               </div>

               <h2>[부 칙]</h2>
               <div class="terms-conditions">
                 1. (시행일) 이 약관은 2019년 10월 1일부터 시행합니다.<br>
                 2. (경과조치) 이 약관 시행일 전부터 이용자로 등록하여 홈페이지 정보서비스를 이용하고 있는 이용자가 이 약관에 동의하지 않는 경우에는 이용자 등록을 취소하여야 합니다.<br>
                 만일, 이 약관 시행일로 부터 3개월 이내에 회원등록을 취소하지 않는 이용자는 이 약관 내용에 동의하는 것으로 간주합니다.
               </div>
             </div>
            </div>
            <ul class="radioList taC aniBox type_bot gogo">
              <li><label class="radioArea"><input type="radio" name="agreeTerms" value="Y" v-model="agreeCheck.agreeTerms"><span class="fakeRadiobox"></span> 동의합니다. </label></li>
              <li><label class="radioArea"><input type="radio" name="agreeTerms" value="N" v-model="agreeCheck.agreeTerms"><span class="fakeRadiobox"></span> 동의하지 않습니다. </label></li>
            </ul>
          </div>
          <div class="conTitWrap mgb10 aniBox type_left gogo">
            <strong>DAMDA 개인정보처리방침</strong>
          </div>
          <div class="policyWrap">
            <div class="policy aniBox type_bot gogo">
              <div class="terms-box" style="height:auto;border:0">
                <h2>제1조 (개인정보의 처리목적)</h2>
                <div class="terms-conditions">
                  ① 담다는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 개인정보 보호법 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.<br><br>
                  1. 홈페이지 회원 가입 및 관리<br>
                  회원 가입의사 확인, 회원제 서비스 제공에 따른 본인 식별&nbsp;·&nbsp;인증, 회원자격 유지&nbsp;·&nbsp;관리, 제한적 본인확인제 시행에 따른 본인확인, 서비스 부정이용 방지, 각종 고지&nbsp;·&nbsp;통지 등을 목적으로 개인정보를 처리합니다.<br>
                  2. 수집하는 개인정보의 항목 : 회사명, 이름,  전화번호, 휴대전화번호, 이메일, 직위 등을 수집합니다.<br>
                  3. 개인정보 수집방법 : 회원가입자의 작성을 통해 수집합니다.
                </div>
                <h2>제2조 (개인정보의 처리 및 보유기간)</h2>
                <div class="terms-conditions">
                  ① 담다는 법령에 따른 개인정보 보유&nbsp;·&nbsp;이용기간 또는 정보주체로부터 개인정보를 수집 시에 동의 받은 개인정보 보유&nbsp;·&nbsp;이용기간 내에서 개인정보를 처리&nbsp;·&nbsp;보유합니다.<br>
                  ② 각각의 개인정보 처리 및 보유 기간은 다음과 같습니다.<br><br>
                  1. 홈페이지 회원 가입 및 관리 : 회원가입자(정보주체)가 회원가입을 완료한 날로부터 1년<br>
                  다만, 다음의 사유에 해당하는 경우에는 해당 사유 종료시까지<br>
                  1) 관계 법령 위반에 따른 수사&nbsp;·&nbsp;조사 등이 진행중인 경우에는 해당 수사&nbsp;·&nbsp;조사 종료시까지<br>
                  2) 홈페이지 이용에 따른 채권&nbsp;·&nbsp;채무관계 잔존 시에는 해당 채권&nbsp;·&nbsp;채무관계 정산시까지<br>
                  2.「정보통신망 이용촉진 및 정보보호 등에 관한 법률」시행령 제29조에 따른 본인확인정보 보관 : 게시판에 정보 게시가 종료된 후 6개월<br>
                  3. 담다는 법령에 따른 개인정보 보유&nbsp;·&nbsp;이용기간 또는 정보주체로부터 개인정보를 수집 시에 동의 받은 개인정보 보유&nbsp;·&nbsp;이용기간 내에서 개인정보를 처리&nbsp;·&nbsp;보유합니다.
                </div>
                <h2>제3조 (개인정보의 제3자 제공)</h2>
                <div class="terms-conditions">
                  ① 담다는 정보주체의 동의, 법률의 특별한 규정 등 개인정보 보호법 제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다.
                </div>
              </div>
            </div>
            <ul class="radioList taC aniBox type_bot gogo">
              <li><label class="radioArea"><input type="radio" name="agreePersonal" value="Y" v-model="agreeCheck.agreePersonal"><span class="fakeRadiobox"></span> 동의합니다. </label></li>
              <li><label class="radioArea"><input type="radio" name="agreePersonal" value="N" v-model="agreeCheck.agreePersonal"><span class="fakeRadiobox"></span> 동의하지 않습니다. </label></li>
            </ul>

            <div class="btn_area taC aniBox type_top gogo">
              <a href="javascript:" @click="nextStep()" class="btn_blue" id="">다음</a><router-link to="/" class="btn_vm">취소</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </section>

  <section class="sub-content membership" v-if="step==2">
  <form @submit.prevent="onSubmit">
  <ValidationObserver v-slot="{ invalid, valid, handleSubmit, errors }" ref="registObserve" @submit.prevent>
  <div id="container" class="login">
     <div class="joinDamda">
       <div class="joinTit aniBox2  gogo">
         <center>회원가입은 간단합니다.</center>
         <strong>회원가입</strong>
         <p>STEP 2. 정보입력</p>
       </div>
       <div class="joinBox">
           <div class="joinStep01 aniBox">
             <div class="infoBox bg_gray aniBox type_bot gogo mt0 mb0">
               <strong>가입정보 입력화면 입니다. 정확한 정보 입력을 해 주시기 바랍니다.<br>
               모든 입력란(* 표시)은 필수항목입니다.</strong>
             </div>
             <div class="inputArea">
               <dl>
                 <dt>아이디 <strong class="atSign">*</strong> <span>(이메일)</span></dt>
                 <dd class="inputBox">
                 <ValidationProvider name="userId" rules="required|email" v-slot="{ errors, valid, invalid }">
                   <input type="text" name="userId" class="input_ty1" autocomplete="off" placeholder="아이디는 이메일 형식입니다." v-model="userInfo.userId" @change="userIdChanged()" >
                   <a href="javascript:" :class="{'btn_gray':true, 'disabled':invalid}" :disabled="invalid" @click="checkUserIdDup()">중복확인</a>
                   <span class="is-invalid">{{ errors[0] }}</span>
                   <span v-if="!checkIdDup&&valid" class="is-invalid">아이디 중복 확인이 필요합니다.</span>
                   <span v-if="checkIdDup&&valid" class="is-valid">아이디 중복 확인 완료</span>
                   <p class="txtred">이메일 주소는 가급적 회사 메일주소를 사용해 주세요.</p>
                 </ValidationProvider>
                 </dd>
               </dl>
               <ValidationObserver>
               <dl>
                 <dt>비밀번호 <strong class="atSign">*</strong></dt>
                 <dd class="inputBox">
                  <ValidationProvider  vid="confirmation" :rules="{ required:true, min:10, max:15, regex:/^(?=.*[A-Za-z])(?=.*\d)(?=.*[~^@$!%*#?&])[A-Za-z\d~^@$!%*#?&]{10,15}$/ }" v-slot="{ errors }">
                   <input type="password" name="userPasswd" minlength=10 maxlength=15 autocomplete="off" class="input_ty2" placeholder="비밀번호를 입력하세요." v-model="userInfo.userPasswd">
                   <span class="is-invalid">{{ errors[0] }}</span>
                  </ValidationProvider>
                   <p class="txtred">영문, 숫자, 특수문자 포함하여 10~15자 이내로 입력</p>
                 </dd>
               </dl>
               <dl>
                 <dt>비밀번호 확인 <strong class="atSign">*</strong></dt>
                 <dd class="inputBox">
                  <ValidationProvider name="confirm" :rules="{ required:true, min:10, max:15, confirmed:'confirmation'}" v-slot="{ errors }">
                   <input type="password" name="userPasswdRe" minlength=10 maxlength=15 autocomplete="off" class="input_ty2" placeholder="비밀번호를 한번더 입력하세요." v-model="confirmPassword">
                   <span class="is-invalid">{{ errors[0] }}</span>
                  </ValidationProvider>
                 </dd>
               </dl>
               </ValidationObserver>
               <dl>
                 <dt>회사명 <strong class="atSign">*</strong></dt>
                 <dd class="inputBox">
                  <ValidationProvider name="compName" rules="required" v-slot="{ errors }">
                   <input type="text" name="compName" class="input_ty1" placeholder="검색하세요." v-model="selectedOrgName" readonly>
                   <a href="javascript:" class="btn_gray" @click="openCompSearch()">회사명 검색</a>
                   <span class="is-invalid">{{ errors[0] }}</span>
                  </ValidationProvider>
                 </dd>
               </dl>
               <dl>
                 <dt>부서명 <strong class="atSign">*</strong></dt>
                 <dd class="inputBox">
                  <ValidationProvider name="department" rules="required" v-slot="{ errors }">
                   <input type="text" name="department" class="input_ty2" placeholder="부서명을 입력하세요." v-model="userInfo.partName">
                   <span class="is-invalid">{{ errors[0] }}</span>
                  </ValidationProvider>
                 </dd>
               </dl>
               <dl>
                 <dt>직책 <strong class="atSign">*</strong></dt>
                 <dd class="inputBox">
                  <ValidationProvider name="duty" rules="required" v-slot="{ errors }">
                   <input type="text" name="duty" class="input_ty2" placeholder="직책을 입력하세요." v-model="userInfo.orgStaffPosition">
                   <span class="is-invalid">{{ errors[0] }}</span>
                  </ValidationProvider>
                 </dd>
               </dl>
               <dl>
                 <dt>성명 <strong class="atSign">*</strong></dt>
                 <dd class="inputBox">
                  <ValidationProvider name="userName" rules="required" v-slot="{ errors }">
                   <input type="text" name="userName" class="input_ty2" placeholder="성명을 입력하세요." v-model="userInfo.userName">
                   <span class="is-invalid">{{ errors[0] }}</span>
                  </ValidationProvider>
                 </dd>
               </dl>
               <dl>
                 <dt>유선 전화번호 <strong class="atSign">*</strong></dt>
                 <dd class="inputBox type_tel">
                   <ValidationProvider rules="required|integer|max:3" v-slot="{ errors, invalid, dirty }">
                   <input type="tel" maxlength=3 oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"  pattern="\d*" id="p1" name="phone_1" :class="{'input_ty2': true, 'is-invalid-f': invalid && dirty}" :placeholder="invalid?errors[0]:''" onkeyup="return setAutoTab(this, 3, event);" v-model="orgPhone1">
                   </ValidationProvider>
                   <ValidationProvider rules="required|integer|max:4" v-slot="{ errors, invalid, dirty }">
                   <input type="tel" maxlength=4 oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"  pattern="\d*" id="p2" name="phone_2" :class="{'input_ty2': true, 'is-invalid-f': invalid && dirty}" :placeholder="invalid?errors[0]:''" onkeyup="return setAutoTab(this, 4, event);" v-model="orgPhone2">
                   </ValidationProvider>
                   <ValidationProvider rules="required|integer|max:4" v-slot="{ errors, invalid, dirty }">
                   <input type="tel" maxlength=4 oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"  pattern="\d*" id="p3" name="phone_3" :class="{'input_ty2': true, 'is-invalid-f': invalid && dirty}" :placeholder="invalid?errors[0]:''" onkeyup="return setAutoTab(this, 4, event);" v-model="orgPhone3">
                   </ValidationProvider>
                 </dd>
               </dl>
               <dl>
                 <dt>휴대폰 번호 <strong class="atSign">*</strong></dt>
                 <dd class="inputBox type_tel">
                  <ValidationProvider rules="required|integer|max:3" v-slot="{ errors, invalid, dirty }">
                   <input type="tel" maxlength=3 oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"  pattern="\d*" id="m1" name="mobile_1" :class="{'input_ty2': true, 'is-invalid-f': invalid && dirty}" :placeholder="invalid?errors[0]:''" onkeyup="return setAutoTab(this, 3, event);" v-model="userPhone1">
                  </ValidationProvider>
                  <ValidationProvider rules="required|integer|max:4" v-slot="{ errors, invalid, dirty }">
                   <input type="tel" maxlength=4 oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"  pattern="\d*" id="m2" name="mobile_2" :class="{'input_ty2': true, 'is-invalid-f': invalid && dirty}" :placeholder="invalid?errors[0]:''" onkeyup="return setAutoTab(this, 4, event);" v-model="userPhone2">
                  </ValidationProvider>
                  <ValidationProvider rules="required|integer|max:4" v-slot="{ errors, invalid, dirty }">
                   <input type="tel" maxlength=4 oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"  pattern="\d*" id="m3" name="mobile_3" :class="{'input_ty2': true, 'is-invalid-f': invalid && dirty}" :placeholder="invalid?errors[0]:''" onkeyup="return setAutoTab(this, 4, event);" v-model="userPhone3">
                  </ValidationProvider>
                 </dd>
               </dl>
               <dl style="margin-bottom: 40px;">
                 <dt>이메일 수신동의</dt>
                 <dd class="inputBox">
                   <strong>이메일 수신 여부에 동의하십니까?</strong>
                   <div>
                   <label class="radioArea"><input type="radio" name="agree" value="Y" v-model="userInfo.emailRecvYn"><span class="fakeRadiobox"></span> 동의</label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                   <label class="radioArea"><input type="radio" name="agree" value="N" v-model="userInfo.emailRecvYn"><span class="fakeRadiobox"></span> 미동의</label>
                   </div>
                   <p>※ 미동의 시 담다에서 발송되는 교육 안내 등의 정보를 수신 받을 수 없습니다.</p>
                 </dd>
               </dl>
               <div class="btn_area taC aniBox type_top gogo">
                 <a href="javascript:" class="btn_blue" id="" @click="saveMember" >다음</a><router-link to="/" class="btn_vm">취소</router-link>
               </div>
             </div>
           </div>
       </div>
     </div>
   </div>
   </ValidationObserver>
   </form>
   <modals-container @childs-event="parentsMethod" />
   <loading :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="fullPage"></loading>
  </section>
  <section class="sub-content membership" v-if="step==3">
  <div id="container" class="login">
    <div class="joinDamda">
      <div class="joinTit aniBox2  gogo">
        <center>회원가입은 간단합니다.</center>
        <strong>회원가입</strong>
        <p>STEP 3. 신청완료</p>
      </div>
      <div class="joinBox">
        <div class="joinStep01 aniBox">
          <h1>회원가입 신청이 완료 되었습니다.</h1>
          <h3>관리자 승인 후 정식 가입이 완료됩니다. 가입 승인 메일을 확인 하시기 바랍니다.</h3>
          <center><img src="/static/images/common/DAMDA_logo.png" alt=""/></center>
          <div class="infoBox bg_gray aniBox type_bot gogo mb10">
            <strong>승인 메일이 도착하지 않을 경우 02-6338-6112 으로 문의 주시기 바랍니다.</strong>
          </div>
          <div class="btn_area taC aniBox type_top gogo">
            <router-link to="/" class="btn_vm">확인</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
  </section>
</div>
</template>

<script>
import axios from 'axios'
import { ValidationProvider, ValidationObserver, extend, localize } from 'vee-validate'
import { required, email, between, confirmed, min, max, regex, integer } from 'vee-validate/dist/rules'
import ko from 'vee-validate/dist/locale/ko.json'
import CompSearchPopup from './popup/CompanySearch.vue'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

localize(ko)
extend('required', {
  ...required,
  message: '필수 입력 항목입니다.'
})
extend('email', {
  ...email,
  message: '이메일 형식이 필요합니다.'
})
extend('between', {
  ...between,
  message: '비밀번호 길이를 확인해주세요'
})
extend('confirmed', {
  ...confirmed,
  message: '비밀번호 확인값과 일치하지 않습니다.'
})
extend('min', {
  ...min,
  message: '값이 {length}자리 이상이어야 합니다.'
})
extend('max', {
  ...max,
  message: '값이 {length}자리 이하이어야 합니다.'
})
extend('regex', {
  ...regex,
  message: '비밀번호는 영문과 숫자, 특수문자가 포함되어야 합니다.'
})
extend('integer', {
  ...integer,
  message: '숫자로만 입력하세요'
})

export default {
  name: 'MemberRegist',
  components: {
    ValidationProvider,
    ValidationObserver,
    Loading
  },
  data () {
    return {
      step: 1,
      agreeCheck: {
        agreeTerms: '',
        agreePersonal: '',
        agreeAll: ''
      },
      userInfo: {
        userId: '',
        userName: '',
        userPasswd: '',
        orgInfo: {
          keyid: ''
        },
        orgName: '',
        partName: '',
        orgPhone: '',
        userPhone: '',
        emailRecvYn: 'Y',
        orgIdx: ''
      },
      checkIdDup: false,
      orglist: [],
      orgPhone1: '',
      orgPhone2: '',
      orgPhone3: '',
      userPhone1: '',
      userPhone2: '',
      userPhone3: '',
      selectedOrgName: '',
      confirmPassword: '',
      isLoading: false,
      fullPage: true
    }
  },
  created () {
  },
  mounted () {
    this.$parent.showHeader = false
    this.$parent.showFooter = false
    axios.interceptors.request.use((config) => {
      return config
    }, (error) => {
      return Promise.reject(error)
    })
    axios.interceptors.response.use((response) => {
      return response
    }, (error) => {
      return Promise.reject(error)
    })
  },
  destroyed () {
    this.$parent.showHeader = true
    this.$parent.showFooter = true
  },
  methods: {
    openCompSearch: function () {
      this.$modal.show(CompSearchPopup, {
        modal: this.$modal }, {
        name: 'compSearchPopup',
        width: '100%',
        maxWidth: 500,
        minHeight: 900,
        height: 'auto',
        draggable: false,
        adaptive: true,
        resizable: true,
        scrollable: true
      })
    },
    getDupResult: function () {
      return this.checkIdDup
    },
    nextStep: function () {
      window.scrollTo(0, 0)
      if (this.agreeCheck.agreeTerms === 'Y' && this.agreeCheck.agreePersonal === 'Y') {
        this.step = 2
      } else {
        alert('이용약관 및 개인정보처리방침에 동의하셔야 가입하실 수 있습니다.')
      }
    },
    checkUserIdDup: function () {
      var _this = this
      const url = '/web/api/member/checkId?id=' + this.userInfo.userId
      axios.get(url, {withCredentials: true})
        .then(function (response) {
          if (response.data) {
            alert('사용 가능한 아이디입니다.')
            _this.checkIdDup = true
          } else {
            alert('사용할 수 없는 아이디입니다.')
            _this.checkIdDup = false
          }
        })
        .catch(function (error) {
          alert('오류가 발생하였습니다. 관리자에게 문의하여 주십시오')
          console.log('ERR', error)
        })
    },
    getOrgList: function () {
      var _this = this
      // 기업목록조회
      const url = '/web/api/org'
      axios.get(url, {withCredentials: true})
        .then(function (response) {
          if (response.status === 200) {
            _this.orglist = response.data
          } else {
            alert('목록 조회에 실패하였습니다. 잠시 후 다시 이용 부탁드립니다.')
          }
        })
        .catch(function () {
          alert('오류가 발생하였습니다. 관리자에게 문의하여 주십시오')
        })
    },
    userIdChanged: function () {
      this.checkIdDup = false
    },
    async saveMember () {
      var _this = this
      // Check ID Dup
      if (!this.checkIdDup) {
        alert('아이디 중복 체크를 해주세요')
        return
      }

      const isValid = await _this.$refs.registObserve.validate()

      if (isValid) {
        _this.userInfo.orgPhone = _this.orgPhone1 + _this.orgPhone2 + _this.orgPhone3
        _this.userInfo.userPhone = _this.userPhone1 + _this.userPhone2 + _this.userPhone3
        _this.userInfo.orgName = _this.selectedOrgName
        _this.isLoading = true
        axios({
          method: 'POST',
          url: '/web/api/member',
          data: _this.userInfo,
          withCredentials: true
        }).then((response) => {
          _this.isLoading = false
          if (response.data === 'success') {
            _this.step = 3
          } else {
            alert('저장에 실패하였습니다. 잠시 후 다시 이용 부탁드립니다.')
          }
        }).catch((ex) => {
          _this.isLoading = false
          alert('오류가 발생하였습니다. 관리자에게 문의하여 주십시오')
          console.log('사용자 회원 가입 오류 : ', ex)
        })
      } else {
        alert('입력값을 확인해주세요')
      }
    },
    gohome: function () {
      this.$router.push('/')
    },
    chkPwd: function (pwd) {
      var pw = pwd
      var num = pw.search(/[0-9]/g)
      var eng = pw.search(/[a-z]/ig)
      var spe = pw.search(/[`~!@@#$%^&*|₩₩₩'₩";:₩/?]/gi)
      if (pw.length < 8 || pw.length > 20) {
        alert('8자리 ~ 20자리 이내로 입력해주세요.')
        return false
      } if (pw.search(/₩s/) !== -1) {
        alert('비밀번호는 공백없이 입력해주세요.')
        return false
      } if (num < 0 || eng < 0 || spe < 0) {
        alert('영문,숫자, 특수문자를 혼합하여 입력해주세요.')
        return false
      }
      return true
    },
    parentsMethod: function (data) {
      var _this = this
      _this.selectedOrgName = data.orgName
      _this.userInfo.orgIdx = data.orgId
      _this.userInfo.orgNo = data.orgNo
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.autocomplete-wrap {position:relative; z-index:50;}
.autocomplete {position:absolute; left:25px; right:0; margin-top:-8px; background:#fff; border:1px solid #ddd; max-height:400px; width:412px; overflow:auto;}
.autocomplete li a {display:block; padding-left:6px;}
.autocomplete li a:hover {background:#f8f9f9;}
.autocomplete li .tit {font-size:14px;}
.autocomplete li .tit span {font-weight:20;}

#registSection {
  display : none;
}
#completeSection {
  display : none;
}
a.disabled {
    pointer-events: none;
}
.is-valid { color:blue; line-height: 3; padding-left: 20px;}
.is-invalid { color:red;  line-height: 3; padding-left: 20px;}
.is-invalid-f { border-color:red }
</style>



// WEBPACK FOOTER //
// src/components/MemberRegist.vue